import { render, staticRenderFns } from "./FormInfoPage.vue?vue&type=template&id=755e1a66&scoped=true"
import script from "./FormInfoPage.vue?vue&type=script&lang=js"
export * from "./FormInfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e1a66",
  null
  
)

export default component.exports